var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgDashboardsStandard = function SvgDashboardsStandard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 40 40",
    width: "1em",
    height: "1em",
    fill: "currentColor"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    fill: "#6cb8ef",
    d: "M20 2a18 18 0 100 36 18 18 0 100-36z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 8h24v24H8z",
    fill: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27 13v2h-4v-2h4m-10 0v6h-4v-6h4m10 8v6h-4v-6h4m-10 4v2h-4v-2h4m12-14h-8v6h8zm-10 0h-8v10h8zm10 8h-8v10h8zm-10 4h-8v6h8z",
    fill: "#6cb8ef"
  })));
};
export default SvgDashboardsStandard;